import { useFlags } from "launchdarkly-react-client-sdk";
import { useMemo } from "react";

import "react-datepicker/dist/react-datepicker.css";

import MaintenanceScreen from "@equidefi/portals/components/MaintenanceScreen";
import { useCurrentUser, useIdentifyLDUser } from "@equidefi/portals/hooks/useUsers";
import { initializeZxcvbn, isAdmin } from "@equidefi/shared";

import AppRoutes from "./Routes";

const App = () => {
  const { data: me } = useCurrentUser();
  const admin = useMemo(() => isAdmin(me), [me]);
  initializeZxcvbn();

  useIdentifyLDUser(me);
  const flags = useFlags();

  if (flags.maintenanceMode) return <MaintenanceScreen />;

  return <AppRoutes isAdmin={admin} />;
};

export default App;
